import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { BREAKPOINTS } from "../styles/variables/Breakpoints";
import { HEADER_HEIGHT } from "../config";

const TestingGlobal = createGlobalStyle`
  :root { --header-height: ${HEADER_HEIGHT}px; }
`;

const MockHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: ${HEADER_HEIGHT}px;
  background: #111;
  color: #fff;
  z-index: 9998;
  display: flex;
  align-items: center;
  padding: 0 24px;
  font-family: "univers-light", sans-serif;
  font-size: 13px;
  letter-spacing: 0.04em;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);

  @media (max-width: ${BREAKPOINTS.sm}px) {
    position: sticky;
  }
`;

const MockFooter = styled.footer`
  position: relative;
  z-index: 9997;
  height: 200px;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "univers-light", sans-serif;
  font-size: 13px;
  color: #888;
  letter-spacing: 0.04em;
  border-top: 1px solid #ddd;
`;

const TestLabel = styled.span`
  margin-left: auto;
  background: rgba(255, 255, 255, 0.12);
  padding: 3px 10px;
  border-radius: 3px;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  opacity: 0.7;
`;

const ContentWrapper = styled.div`
  padding-top: ${HEADER_HEIGHT}px;
  min-height: 100vh;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    padding-top: 0;
  }
`;

const TestShell = ({ children }) => (
  <>
    <TestingGlobal />
    <MockHeader>
      Highsnobiety
      <TestLabel>Testing — {HEADER_HEIGHT}px header</TestLabel>
    </MockHeader>
    <ContentWrapper>{children}</ContentWrapper>
    {/* <MockFooter>Footer (Production)</MockFooter> */}
  </>
);

export default TestShell;
